/**
 * Server error codes that describe one field. The API reports @Valid violations as
 * `fieldErrors`, but service-layer rejections (a taken mobile, a weak password)
 * arrive as a `code` on the envelope — this maps those back onto the field that
 * caused them, so both kinds of rejection surface in the same place.
 */
export const REGISTRATION_CODES = {
  mobile_taken: 'mobile',
  email_taken: 'email',
  weak_password: 'password',
  identifier_invalid: 'mobile',
  // The registration form's pickers. Each rejection names the field it came from, so a
  // master row switched off between loading the form and submitting it says which
  // answer to change rather than only that something was wrong.
  invalid_state: 'state',
  invalid_subject: 'subjects',
  invalid_designation: 'designation',
  invalid_class_level: 'classLevels',
  invalid_title: 'titles',
};

/**
 * The student form carries no field called `mobile` — its one number is the parent's — so
 * a duplicate has to land on `parentMobile` instead. Without this the rejection would be
 * marked handled, render on a field that is not on the screen, and suppress the banner:
 * a sibling registering on the same number would see nothing happen at all.
 */
export const STUDENT_REGISTRATION_CODES = {
  ...REGISTRATION_CODES,
  mobile_taken: 'parentMobile',
  identifier_invalid: 'parentMobile',
};

export const LOGIN_CODES = {
  identifier_invalid: 'identifier',
  identifier_required: 'identifier',
  otp_incorrect: 'otp',
  otp_expired: 'otp',
  otp_invalid: 'otp',
  otp_locked: 'otp',
  weak_password: 'newPassword',
};

export const PASSWORD_CODES = {
  invalid_password: 'currentPassword',
  weak_password: 'newPassword',
};

export const UPLOAD_CODES = {
  id_proof_required: 'idProof',
  file_too_large: 'idProof',
  unsupported_file_type: 'idProof',
  upload_failed: 'idProof',
};
